import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@xiltrion/ui/command';
import { Icono } from '@xiltrion/ui/icono';
import { apiGet } from '@/api/client';
import { useTerms } from '@/app/session';

interface Results { projects: Array<{ id: string; name: string }>; tasks: Array<{ id: string; number: number; title: string; completedAt: string | null }>; goals: Array<{ id: string; title: string; code: string | null }> }

/** Búsqueda global ⌘K: proyectos, tareas (por título, texto o número T-123) y objetivos; además, atajos. */
export function SearchPalette({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  const navigate = useNavigate();
  const { t } = useTerms();
  const [q, setQ] = useState('');
  const [debounced, setDebounced] = useState('');
  useEffect(() => {
    const h = setTimeout(() => setDebounced(q), 200);
    return () => clearTimeout(h);
  }, [q]);
  const { data } = useQuery({ queryKey: ['search', debounced], queryFn: () => apiGet<Results>('/search', { q: debounced }), enabled: debounced.trim().length >= 2 });
  const go = (path: string) => { onOpenChange(false); setQ(''); navigate(path); };
  return (
    <CommandDialog open={open} onOpenChange={onOpenChange} title="Buscar" shouldFilter={false}>
      <CommandInput placeholder="Buscar proyectos, tareas (T-123), objetivos…" value={q} onValueChange={setQ} />
      <CommandList>
        <CommandEmpty>{debounced.length < 2 ? 'Escribe al menos dos letras.' : 'Sin resultados.'}</CommandEmpty>
        {!debounced && (
          <CommandGroup heading="Ir a">
            <CommandItem onSelect={() => go('/')}><Icono nombre="mdi:home-outline" />Inicio</CommandItem>
            <CommandItem onSelect={() => go('/mis-tareas')}><Icono nombre="mdi:account-check-outline" />Mis tareas</CommandItem>
            <CommandItem onSelect={() => go('/proyectos')}><Icono nombre="mdi:folder-outline" />{t('project', true)}</CommandItem>
            <CommandItem onSelect={() => go('/bandeja')}><Icono nombre="mdi:inbox-arrow-down-outline" />Bandeja</CommandItem>
          </CommandGroup>
        )}
        {!!data?.projects.length && <CommandGroup heading={t('project', true)}>{data.projects.map((p) => <CommandItem key={p.id} value={`p-${p.id}`} onSelect={() => go(`/proyectos/${p.id}`)}><Icono nombre="mdi:folder-outline" />{p.name}</CommandItem>)}</CommandGroup>}
        {!!data?.tasks.length && <CommandGroup heading={t('task', true)}>{data.tasks.map((x) => <CommandItem key={x.id} value={`t-${x.id}`} onSelect={() => go(`/tareas/${x.id}`)}><Icono nombre={x.completedAt ? 'mdi:check-circle-outline' : 'mdi:checkbox-blank-circle-outline'} /><span className="tnum text-muted-foreground">T-{x.number}</span>{x.title}</CommandItem>)}</CommandGroup>}
        {!!data?.goals.length && <CommandGroup heading={t('goal', true)}>{data.goals.map((g) => <CommandItem key={g.id} value={`g-${g.id}`} onSelect={() => go(`/objetivos?nodo=${g.id}`)}><Icono nombre="mdi:target" />{g.code ? `${g.code} ` : ''}{g.title}</CommandItem>)}</CommandGroup>}
      </CommandList>
    </CommandDialog>
  );
}
